import {
  apiStage,
  desarquivadosAppApiKey,
  desarquivadosPaymentsApiKey,
  desarquivadosAppApiUrl,
  desarquivadosPaymentsApiUrl,
  desarquivadosAppApiUrlOutsideVPC,
  desarquivadosOutsideVPCApiKey,
} from "./urls";

const getHeaders = (payments = false, outsideVPC = false) => {
  let apiKey: string;

  switch (true) {
    case payments:
      apiKey = desarquivadosPaymentsApiKey || "";
      break;
    case outsideVPC:
      apiKey = desarquivadosOutsideVPCApiKey || "";
      break;
    default:
      apiKey = desarquivadosAppApiKey || "";
      break;
  }

  const HEADERS = {
    "Content-Type": "application/json",
    "X-Api-Key": apiKey,
    Accept: "application/json",
  };

  return HEADERS;
};

const getData = async (
  endpoint: string,
  params: Record<string, string> = {},
  payments = false
) => {
  const url = new URL(
    `${payments ? desarquivadosPaymentsApiUrl : desarquivadosAppApiUrl}/${apiStage}/${endpoint}`
  );
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );

  const response = await fetch(url, {
    method: "GET",
    headers: getHeaders(payments),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || "Network response was not ok");
  }
  return response.json();
};

const postData = async (
  endpoint: string,
  params: Record<string, string> = {},
  body: Record<string, any> = {},
  payments = false,
  outsideVPC = false
) => {
  let baseUrl: string;

  switch (true) {
    case payments:
      baseUrl = desarquivadosPaymentsApiUrl;
      break;
    case outsideVPC:
      baseUrl = desarquivadosAppApiUrlOutsideVPC;
      break;
    default:
      baseUrl = desarquivadosAppApiUrl;
      break;
  }

  const url = new URL(`${baseUrl}/${apiStage}/${endpoint}`);

  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );

  const response = await fetch(url, {
    method: "POST",
    headers: getHeaders(payments, outsideVPC),
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || "Network response was not ok");
  }
  return response.json();
};

const deleteData = async (
  endpoint: string,
  params: Record<string, string> = {}
) => {
  const url = new URL(`${desarquivadosAppApiUrl}/${apiStage}/${endpoint}`);
  Object.keys(params).forEach((key) =>
    url.searchParams.append(key, params[key])
  );

  const response = await fetch(url, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || "Network response was not ok");
  }
  return response.json();
};

export { getData, postData, deleteData };
